/**
 * @module Task
 * Container Component Task List
 */
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {useDispatch, useSelector} from 'react-redux';
import Utility from '../../../util/utilityfunctions';
import {currentResource, labels} from '../../../util/utils';
import {clearErrors} from '../../../actions/erroractions';
import {alertIcError24px, actionIcCheckCircle24px} from '@ey/motif-react-wrapper/assets/icons/index';
import Icon from '../BaseComponentWrappers/MotifIcon';
import Toast from '@ey/motif-react-wrapper/Toast';

export function ErrorSummary(props) {
	const hideError = () => {
		dispatch(clearErrors()).then(() => {
			setMessage(undefined);
			setLevel('');
		});
	};

	useEffect(() => {
		if (props.closeError) {
			hideError();
		}
	}, [props.closeError]);

	const {errorMessage, errorLevel} = useSelector((store) => {
		return {
			errorMessage: store.errors.message || (typeof store.errors === 'string' && store.errors) || undefined,
			errorLevel: store.errors.level || 'error'
		};
	});

	const [message, setMessage] = useState(errorMessage);
	const [level, setLevel] = useState('');

	const isRbac = useSelector((store) => {
		if (store.errors['RBACV2-Global']) {
			return true;
		}
		return false;
	});

	const error = useSelector((store) => {
		if (store.errors['RBACV2-Global']) {
			return store.errors['RBACV2-Global'];
		}
	});

	const isAresView = useSelector((store) => {
		if (store.isAresView) {
			return store.isAresView;
		}
	});

	const dispatch = useDispatch();

	useEffect(() => {
		if (isRbac === true) {
			if (error.length > 0) {
				let errorCode = 0;
				if (error[0].indexOf(' - ') > 0) {
					errorCode = error[0].substr(0, error[0].indexOf(' -'));
				} else {
					errorCode = JSON.parse(JSON.stringify(error[0]));
				}
				let m = '<strong>' + errorCode + ': ' + '</strong>' + currentResource.RbacErrors[errorCode];
				return setMessage(m);
			}
		} else if (errorMessage) {
			let m = Utility.getErrorMessageFromResponse(errorMessage);
			if (m === 'Network Error') {
				m = labels.NetworkErrorMessage;
			}
			setLevel(errorLevel);
			return setMessage(m);
		} else {
			setMessage(undefined);
			setLevel(errorLevel);
		}

		setLevel(errorLevel);
	}, [isRbac, error, errorMessage, errorLevel]);

	return (
		<>
			{message && level ? (
				<StyledToast variant={level === 'success' ? 'success' : 'error'}>
					{Utility.createRichTextElement(message)}
				</StyledToast>
			) : null}
		</>
	);
}

export default ErrorSummary;

const StyledToast = styled(Toast)`
	position: absolute;
	width: calc(100% - var(--px-48)) !important;
	z-index: 9;
`;

// const StyledErrorContainer = styled.section`
// 	padding: 0;
// 	color: var(--neutrals-900);
// 	width: calc(100% - var(--px-40));
// 	font-size: var(--px-12);
// 	line-height: var(--px-18);
// 	border: var(--px-1) solid var(--neutrals-700);
// 	margin: 0 0 var(--px-15) 0;
// 	position: relative;
// 	display: table;
// 	background: var(--neutrals-00white);
// 	box-shadow: var(--px-1) var(--px-1) var(--px-4) var(--neutrals-300);
// 	&.hide-error-summary {
// 		display: none;
// 	}
// 	.close-icon {
// 		cursor: pointer;
// 		right: var(--px-9);
// 		top: var(--px-9);
// 		fill: var(--neutrals-900);
// 	}
// 	.error-message {
// 		display: inline-block;
// 		padding: var(--px-9) var(--px-10) var(--px-5);
// 		color: var(--neutrals-900);
// 		background: var(--neutrals-00white);
// 		width: calc(100% - var(--px-30));
// 	}
// 	&.ares-error {
// 		box-shadow: 0 0 var(--px-8) 0 rgba(26, 26, 36, 0.2) !important;
// 		border-radius: var(--px-12) !important;
// 		background: var(--neutrals-00white) !important;
// 		border: var(--px-1) solid var(--neutrals-00white) !important;
// 		width: 99%;
// 		display: flex;
// 		align-items: center;
// 		padding: var(--px-9) var(--px-10) var(--px-5);
// 		right: var(--px-6);
// 		top: var(--px-10) !important;
// 		.error-message {
// 			padding: 0 var(--px-12);
// 			font-size: var(--px-14);
// 			font-weight: 300;
// 			line-height: var(--px-22);
// 			flex-grow: 1;
// 			max-width: calc(100% - var(--px-50));
// 			word-break: break-word;
// 			cursor: default;
// 			background: var(--neutrals-00white) !important;
// 			color: var(--neutrals-900) !important;
// 		}
// 		.motif-icon {
// 			display: flex;
// 			svg {
// 				width: var(--px-22) !important;
// 				height: var(--px-22) !important;
// 				max-width: var(--px-22) !important;
// 				max-height: var(--px-22) !important;
// 				display: inline-block;
// 				fill: var(--red-600) !important;
// 				path {
// 					stroke: unset;
// 				}
// 			}
// 			&.success {
// 				svg {
// 					path {
// 						fill: var(--green-500) !important;
// 					}
// 				}
// 			}
// 		}
// 	}
// `;
